module.exports = __webpack_public_path__ + "img/9.0de01a50.jpg";